const paths = {
  overview: 'M4 20V10m8 10V4m8 16v-7',
  operations: 'M3 12h4l3-8 4 16 3-8h4',
  menu: 'M4 3h7a3 3 0 0 1 3 3v15a3 3 0 0 0-3-3H4V3Zm10 3a3 3 0 0 1 3-3h4v15h-4a3 3 0 0 0-3 3',
  guests: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm7 1v6m-3-3h6',
  bookings: 'M8 3v4m8-4v4M3 10h18M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z',
  calls: 'M7 3H4a1 1 0 0 0-1 1c0 9.4 7.6 17 17 17a1 1 0 0 0 1-1v-3l-5-2-2 2a15 15 0 0 1-7-7l2-2-2-5Z',
  settings: 'M4 6h16M4 12h16M4 18h16M8 3v6m8 0v6m-7 0v6',
  activation: 'M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Zm0 0v6h6M8 14h8m-8 3h5',
  voice: 'M4 10v4m4-8v12m4-15v18m4-15v12m4-8v4',
  billing: 'M19 6a8 8 0 1 0 0 12M3 10h12M3 14h11',
  restaurants: 'M3 10h18M5 10v11h14V10M2 10l3-7h14l3 7M9 21v-7h6v7',
  activations: 'M7 17 17 7M7 7h10v10',
  system: 'M3 12h4l3-8 4 16 3-8h4',
  logout: 'M9 4H4v16h5m5-13 5 5-5 5m-5-5h11',
  arrow: 'M4 12h16m-6-6 6 6-6 6',
  search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
};

export default function ProductIcon({ name = 'overview', size = 21 }) {
  return <svg className="rd-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] || paths.overview} /></svg>;
}
